module.exports = __webpack_public_path__ + "static/media/basementl.02b3f3a2.png";